import { ArtifactRenderer, validate } from '@globalwebindex/spec-renderer';
import { artifactTestSpec } from '@static/artifactTestFixture';
import Styled from './ArtifactTestPage.styled';

const validated = validate(artifactTestSpec);

function ArtifactTestPage() {
  if (!validated.success) {
    return (
      <Styled.Shell data-testid="artifact-test">
        <Styled.Content className="overlay-scrollbar">
          <pre>{JSON.stringify(validated.error?.issues, null, 2)}</pre>
        </Styled.Content>
      </Styled.Shell>
    );
  }

  return (
    <Styled.Shell data-testid="artifact-test">
      <Styled.Content className="overlay-scrollbar">
        <Styled.ArtifactCapture>
          <ArtifactRenderer spec={validated.data} />
        </Styled.ArtifactCapture>
      </Styled.Content>
    </Styled.Shell>
  );
}

export default ArtifactTestPage;
